import {
  Circle,
  Recycle,
  Leaf,
  Users,
  Building2,
  Truck,
  MapPin,
  Target,
  TrendingUp,
  Heart,
  Shield,
  Globe,
  Lightbulb,
  Handshake,
  Award,
  CheckCircle,
  TreeDeciduous,
  Factory,
  Briefcase,
  BarChart3,
  Coins,
  Scale,
  Trash2,
  Package,
  Settings,
  Zap,
} from "lucide-react";
import type { LucideIcon } from "lucide-react";
import type { Feature } from "../../types/landingPage";

// Curated icon map - only bundle icons actually used in landing pages
const iconMap: Record<string, LucideIcon> = {
  Circle,
  Recycle,
  Leaf,
  Users,
  Building2,
  Truck,
  MapPin,
  Target,
  TrendingUp,
  Heart,
  Shield,
  Globe,
  Lightbulb,
  Handshake,
  Award,
  CheckCircle,
  TreeDeciduous,
  Factory,
  Briefcase,
  BarChart3,
  Coins,
  Scale,
  Trash2,
  Package,
  Settings,
  Zap,
};

interface AboutSectionProps {
  heading: string;
  paragraph: string;
  features: Feature[];
}

export default function AboutSection({
  heading,
  paragraph,
  features,
}: AboutSectionProps) {
  // Get icon component by name from curated map
  const getIcon = (iconName: string): LucideIcon => {
    return iconMap[iconName] || Circle;
  };

  return (
    <section id="about" className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              {heading}
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              {paragraph}
            </p>
          </div>

          {/* Feature Cards */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {features.map((feature, index) => {
              const IconComponent = getIcon(feature.icon);
              const bgColor = index % 2 === 0 ? "bg-primary/10" : "bg-orange-500/10";
              const iconColor = index % 2 === 0 ? "text-primary" : "text-orange-500";

              return (
                <div
                  key={index}
                  className="bg-white rounded-lg p-6 shadow-sm hover:shadow-md transition-shadow"
                >
                  <div className={`w-16 h-16 rounded-full ${bgColor} flex items-center justify-center mb-4`}>
                    <IconComponent className={`w-8 h-8 ${iconColor}`} />
                  </div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-2">
                    {feature.heading}
                  </h3>
                  <p className="text-gray-600">
                    {feature.description}
                  </p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
